import { render, staticRenderFns } from "./DataPanel.vue?vue&type=template&id=6bcc5a40&scoped=true"
import script from "./DataPanel.vue?vue&type=script&lang=ts"
export * from "./DataPanel.vue?vue&type=script&lang=ts"
import style0 from "./DataPanel.vue?vue&type=style&index=0&id=6bcc5a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc5a40",
  null
  
)

export default component.exports